import { firebaseAuth, firebaseDb } from "@/infrastructure/firebase";
import { slugify } from "@/utils/string";

import React, { useState } from "react";
import { Button, Card, Col, Form, Input, Row, Typography } from "antd";
import { Link, useHistory } from "react-router-dom";
import styles from "./styles.less";
import RegisterImg from "./register.png";
import { LockOutlined, MailOutlined, UserOutlined } from "@ant-design/icons/lib";

const { Text } = Typography;

export default () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [form] = Form.useForm();

  return (
    <div className={styles.loginBackground} style={{ backgroundImage: `url(${RegisterImg})` }}>
      <Row justify="center" align="middle" style={{ height: "100%", marginTop: "-80px" }}>
        <Col style={{ width: 400 }}>
          <Card style={{ borderRadius: 15 }} title={"Register"}>
            <Form onFinish={register_new_user} form={form} className="login-form">
              <Form.Item name="email" rules={[{ required: true, message: "Please input your email!" }]}>
                <Input prefix={<MailOutlined style={{ color: "rgba(0,0,0,.25)" }} />} placeholder="Email" />
              </Form.Item>
              <Form.Item name="username" rules={[{ required: true, message: "Please input your username!" }]}>
                <Input prefix={<UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />} placeholder="Username" />
              </Form.Item>
              <Form.Item name="password" rules={[{ required: true, message: "Please input your Password!" }]}>
                <Input
                  prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
                  type="password"
                  placeholder="Password"
                />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" className={styles.loginButton} loading={loading}>
                  Register
                </Button>
                Or <Link to="/login">login here</Link>
              </Form.Item>
              {error.length > 0 && <Text type="danger">{error}</Text>}
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );

  function register_new_user(e: any) {
    e.preventDefault();
    setError("");
    setLoading(true);
    const { email, username, password } = form.getFieldsValue();

    const user = firebaseDb.collection("users").doc(slugify(username));
    user.get().then(doc => {
      if (doc.exists) {
        setError("This username is already used by others.");
        setLoading(false);
      } else {
        // this username does not yet exists in the db
        setError("");
        firebaseAuth
          .createUserWithEmailAndPassword(email, password)
          .then(cred => {
            cred.user &&
              user.set({
                username,
                email,
                password,
                userId: cred.user.uid,
                watchlist: { Wathclist1: [] },
                userPreference: {},
                priceAlert: []
              });
            history.push("/");
          })
          .catch(e => {
            setError(e.message);
            setLoading(false);
          });
      }
    });
  }
};
